import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPayee401kFundLookup extends Layout {
    sourcePayee401kFundLookup: DataSource;
    tablePayee401kFund: Table;
}
